import { Spin, Table } from 'antd'
import useHook, { Props } from './hook'

export default function CustomTable(props: Props) {
  const {
    columns,
    dataSource,
    isLoading,
    selectedRowKeys,
    handleSelectChange,
  } = useHook(props)
  const {
    bordered = true,
    className,
    pagination = false,
    rowKey = 'id',
    scroll,
    onCheckChange,
  } = props
  return (
    <div className={className}>
      <Spin tip="数据加载中..." spinning={isLoading}>
        <Table
          bordered={bordered}
          columns={columns}
          dataSource={dataSource}
          pagination={pagination}
          rowKey={rowKey}
          rowSelection={
            onCheckChange
              ? {
                  columnWidth: '10px',
                  selectedRowKeys: selectedRowKeys,
                  onChange: handleSelectChange,
                  getCheckboxProps: (record) => ({
                    disabled: record.isDisabled,
                  }),
                }
              : undefined
          }
          scroll={scroll}
        ></Table>
      </Spin>
    </div>
  )
}
import { Spin, Table } from 'antd'
import useHook, { Props } from './hook'

export default function CustomTable(props: Props) {
  const {
    columns,
    dataSource,
    isLoading,
    selectedRowKeys,
    handleSelectChange,
  } = useHook(props)
  const {
    bordered = true,
    className,
    pagination = false,
    rowKey = 'id',
    scroll,
    onCheckChange,
  } = props
  return (
    <div className={className}>
      <Spin tip="数据加载中..." spinning={isLoading}>
        <Table
          bordered={bordered}
          columns={columns}
          dataSource={dataSource}
          pagination={pagination}
          rowKey={rowKey}
          rowSelection={
            onCheckChange
              ? {
                  columnWidth: '10px',
                  selectedRowKeys: selectedRowKeys,
                  onChange: handleSelectChange,
                  getCheckboxProps: (record) => ({
                    disabled: record.isDisabled,
                  }),
                }
              : undefined
          }
          scroll={scroll}
        ></Table>
      </Spin>
    </div>
  )
}
